import { Component, OnInit } from '@angular/core';
import { BlobFileDownloadRequestModel } from '../../../models/blob-file-sas-url.model';
import { DownloadCSV } from '../../../models/download-csv.model';
import { CommonSharedModule } from '../../common/shared.module';
import { DownloadReportService } from '../../services/download-report.service';

@Component({
  selector: 'app-download-csv',
  templateUrl: './download-csv.component.html',
  styleUrls: ['./download-csv.component.scss'],
  standalone: true,
  providers: [DownloadReportService],
  imports: [CommonSharedModule]
})
export class DownloadCsvComponent implements OnInit {
  downloadCSV!: DownloadCSV[];
  loadingIcon = 'fa-circle-o-notch';
  loading = false;
  selectedItem!: DownloadCSV;
  cols: any;

  constructor(private service: DownloadReportService) {}

  ngOnInit() {
    this.getDownloadCSV();
    this.loading = true;
  }

  getDownloadCSV() {
    this.service.getDownloadCSVFilesList().subscribe(downloadReport => {
      this.downloadCSV = downloadReport;
      this.loading = false;
    });
  }

  downloadFile(selectedFile: DownloadCSV) {
    const blobFileDownloadRequestModel: BlobFileDownloadRequestModel = {
      fileName: selectedFile.fileName || '',
      fileUrl: selectedFile.url || ''
    };

    this.service
      .getDownloadCSVFile(blobFileDownloadRequestModel)
      .subscribe(downloadFileSasUrl => {
        window.location.href = downloadFileSasUrl;
      });
  }
}
